<template>
    <div class='foot'>
        <img src="../assets/foot.png" alt="">
        <div class="ICP">
            Copyright ◎ 2015 优成科技 版权所有 
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备15053306号</a>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        };
    },
    methods: {},
}
</script>
<style lang='less' scoped>
.foot{
    position: relative;
    .ICP{
        position: absolute;
        bottom: 20px;
        left: 0;
        right: 0;
        z-index: 999;
        color: #686868;
    }
}
</style>